
export const Theme = {
  menu: [
    'absolute min-w-[400px] z-[999999] bg-white divide-gray-100 rounded-lg shadow-lg overflow-hidden',
    'dark:bg-gray-700'
  ]
};
